import React from 'react';
//import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
//import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import retrieveSecondData from 'views/Expo/retrieveSecondData';
import Paper from '@mui/material/Paper';
import { Box } from '@mui/system';

//import Container from 'components/Container';

const Advantages = ({ secondState, handleCurrentStep }) => {
  if (secondState) {
    retrieveSecondData[0].email = secondState.fatherName;
    retrieveSecondData[0].status = secondState.motherName;

    retrieveSecondData[1].email = secondState.phone;
    retrieveSecondData[1].status = secondState.phone1;

    retrieveSecondData[2].email = secondState.email;
    retrieveSecondData[2].status = secondState.email1;

    retrieveSecondData[3].email = secondState.resadd;
    retrieveSecondData[3].status = secondState.resadd1;

    retrieveSecondData[4].email = secondState.area;
    retrieveSecondData[4].status = secondState.area1;

    retrieveSecondData[5].email = secondState.dist;
    retrieveSecondData[5].status = secondState.dist1;

    retrieveSecondData[6].email = secondState.state;
    retrieveSecondData[6].status = secondState.state1;

    retrieveSecondData[7].email = secondState.country;
    retrieveSecondData[7].status = secondState.country1;

    retrieveSecondData[8].email = secondState.pin;
    retrieveSecondData[8].status = secondState.pin1;

    retrieveSecondData[9].email = secondState.fatherLang;
    retrieveSecondData[9].status = secondState.motherLang;

    retrieveSecondData[10].email = secondState.resnum;
    retrieveSecondData[10].status = secondState.resnum1;

    retrieveSecondData[11].email = secondState.gross;
    retrieveSecondData[11].status = secondState.gross1;
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="">
        <TableHead sx={{ bgcolor: '#377dff' }}>
          <TableRow>
            <TableCell>
              <Typography
                fontWeight={700}
                // sx={{ textTransform: 'uppercase' }}
              ></Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={'caption'}
                color={'white'}
                fontWeight={700}
                sx={{ textTransform: 'uppercase' }}
                marginLeft={17}
              >
                Parents Details
              </Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={'caption'}
                fontWeight={700}
                sx={{ textTransform: 'uppercase' }}
              ></Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={'caption'}
                fontWeight={700}
                sx={{ textTransform: 'uppercase' }}
              ></Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant={'caption'}
                fontWeight={700}
                sx={{ textTransform: 'uppercase' }}
              ></Typography>
            </TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {retrieveSecondData.map((item, i) => (
            <TableRow
              key={i}
              sx={{
                '&:last-child td, &:last-child th': { border: 0 },
              }}
            >
              <TableCell component="th" scope="row">
                <Typography variant={'subtitle2'} fontWeight={700}>
                  {item.name}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {item.email}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant={'subtitle2'} fontWeight={'700'}>
                  {item.title}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {/* //variant={'caption'}
                  //fontWeight={700}
                  //sx={{ color: theme.palette.success.main }} */}

                  {item.status}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color={'text.secondary'} variant={'subtitle2'}>
                  {item.role}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  color={'primary'}
                  variant={'subtitle2'}
                  fontWeight={700}
                  sx={{ cursor: 'pointer' }}
                ></Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Advantages;
